<template>
  <div>
    <!-- Filters Toolbar -->
    <form @submit.prevent>
      <div class="has-background-white rounded-lg pa-md mb-xxs">
        <div class="columns">
          <div class="column">
            <b-select v-model="client" expanded size="is-medium" placeholder="Select Client...">
              <option v-for="client in clients" :key="client.id" :value="client">{{ client.name }}</option>
            </b-select>
          </div>
          <div class="column  is-one-fifth"">
            <b-select v-model="year" expanded @input="loadBillingPeriods" size="is-medium">
              <option value="2025-01-01">2025</option>
              <option value="2024-01-01">2024</option>
              <option value="2023-01-01">2023</option>
            </b-select>
          </div>
          <div class="column is-one-fifth">
            <b-select v-model="startBillingPeriod" expanded size="is-medium">
              <option v-for="period in billingPeriods" :key="period.id" :value="period">{{ period.label }}</option>
            </b-select>
          </div>
          <div class="column is-one-fifth"">
            <b-select v-model="endBillingPeriod" expanded size="is-medium">
              <option v-for="period in billingPeriods" :key="period.id" :value="period">{{ period.label }}</option>
            </b-select>
          </div>
          <div class="column is-narrow">
            <b-button native-type="submit" size="is-medium" type="is-primary" @click="loadReport" outlined>Run</b-button>
          </div>
        </div>
      </div>
    </form>
    <table v-if="metrics.length && billingPeriods.length" class="table is-fullwidth">
      <tr>
        <th class="is-size-8">Metric</th>
        <th v-for="period in billingPeriods" :key="period.id" class="is-size-8 has-text-right">{{ period.short_label }}</th>
      </tr>
      <tr v-for="(row, index) in rows" :key="index">
        <td class="is-size-8">{{ row.label }}</td>
        <td v-for="(metric, index) in metrics" :key="index" class="is-size-8 has-text-right">
          <Currency :value="metric[row.key]" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api']),
    ready () {
      return Boolean(this.client && this.startBillingPeriod && this.endBillingPeriod )
    }
  },
  data () {
    return {
      loadingClients: true,
      loadingBillingPeriods: true,
      clients: [],
      billingPeriods: [],
      year: '2025-01-01',
      startBillingPeriod: null,
      endBillingPeriod: null,
      client: null,
      loadingReport: false,
      results: [],
      metrics: [],
      rows: [{
        label: 'Pending',
        key: 'amount_pending'
      }, {
        label: 'Pending (Cost)',
        key: 'amount_pending_cost'
      }, {
        label: 'Delivered',
        key: 'amount_fulfilled'
      }, {
        label: 'Delivered (Cost)',
        key: 'amount_fulfilled_cost'
      }, {
        label: 'Scheduled',
        key: 'amount_scheduled'
      }, {
        label: 'Billed',
        key: 'amount_billed'
      }, {
        label: 'Expenses',
        key: 'amount_expenses_billable'
      }, {
        label: 'Expenses (Pending)',
        key: 'amount_expenses_pending'
      }, {
        label: 'Expenses (Billable)',
        key: 'amount_expenses_billable'
      }, {
        label: 'Expenses (Non-Billable)',
        key: 'amount_expenses_nonbillable'
      }]
    }
  },

// amount_pending:"0.0000"
// amount_pending_cost:"0.0000"
// amount_scheduled:"0.0000"


  methods: {
    loadClients () {
      const endpoint = this.api.route + '/clients'
      this.loadingClients = true
      this.$http.get(endpoint).then(response => {
        this.clients = response.data.data
      })
    },
    loadBillingPeriods () {
      this.loadingBillingPeriods = true
      const start = this.$dates(this.year).startOf('year')
      const end = this.$dates(this.year).endOf('year')
      const endpoint = this.api.base + 'billing-periods'
      const query = {
        params: {
          start: start.format('YYYY-MM-DD'),
          end: end.format('YYYY-MM-DD'),
          order_by: 'asc'
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.billingPeriods = response.data
        this.startBillingPeriod = this.billingPeriods[0]
        this.endBillingPeriod = this.billingPeriods[this.billingPeriods.length - 1];
      })
    },
    loadReport () {
      this.loadingReport = true
      const endpoint = this.api.route + '/admin/reports/client-period'
      const query = {
        params: {
          client_id: this.client.id,
          start_billing_period_id: this.startBillingPeriod.id,
          end_billing_period_id: this.endBillingPeriod.id
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.metrics = []
        this.data = response.data
        this.billingPeriods.forEach(period => {
          this.data.data.forEach(clientPeriod => {
            if (period.id === clientPeriod.billing_period_id) {
              this.metrics.push({
                billing_period_id: period.id,
                amount_funded: clientPeriod.amount_funded,
                amount_budgeted: clientPeriod.amount_budgeted,
                amount_allocated: clientPeriod.amount_allocated,
                amount_allocated_cost: clientPeriod.amount_allocated_cost,
                amount_pending: clientPeriod.amount_pending,
                amount_pending_cost: clientPeriod.amount_pending_cost,
                amount_fulfilled: clientPeriod.amount_fulfilled,
                amount_fulfilled_cost: clientPeriod.amount_fulfilled_cost,
                amount_expenses_pending: clientPeriod.amount_expenses_pending,
                amount_expenses_billable: clientPeriod.amount_expenses_billable,
                amount_expenses_nonbillable: clientPeriod.amount_expenses_nonbillable,
                amount_scheduled: clientPeriod.amount_scheduled,
                amount_billed: clientPeriod.amount_billed,
              })
            }
          })
        })

        this.data.data.forEach(period => {
          this.results.push()
        })

        this.results = [{
          metric: 'Amount Funded',
          data: [{
            'Dec24': 3432,
            'Dec24': 3432
          }]
        }]
        // this.data.data.forEach(period => {
        //   this.results.push()
        // })
        this.loadingReport = false
      })
    }
  },
  mounted () {
    this.loadClients()
    this.loadBillingPeriods();
  }
}
</script>
